'use client';

import { createContext, ReactNode } from 'react';

// Step 1: Create a Context
export const LanguageContext = createContext<{ lang: string; texts?: { [key: string]: string } }>({
  lang: 'en',
  texts: undefined,
});

export function LanguageProvider({
  children,
  texts,
  lang,
}: {
  children: ReactNode;
  lang: string;
  texts?: { [key: string]: string };
}) {
  return <LanguageContext.Provider value={{ lang: lang, texts: texts }}>{children}</LanguageContext.Provider>;
}
